import { Icon } from '@chakra-ui/react';

export const PencilIcon = (props: any) => (
  <Icon aria-label="pencil icon" {...props}>
    <path
      transform="matrix(.70710678 -.70710678 .70710678 .70710678 -5.514719 11.899495)"
      d="m21.6066017 8.60660172c.5522848 0 1 .44771525 1 1v5.99999998c0 .5522848-.4477152 1-1 1h-3v-7.99999998zm-14.99999998 0v7.99999998l-3-1v-5.99999998zm10.99999998 5.99999998v2h-9.99999998v-2zm-15.02101369-3.9789863.03251248 3.9904851-2.01149877-2.0114988zm15.02101369.9789863v2h-9.99999998v-2zm0-2.99999998v1.99999998h-9.99999998v-1.99999998z"
      fill="currentColor"
    />
  </Icon>
);
